import { createStore } from 'zustand';
import { StafferSlideShows, StudentSlideShows } from '@/types/api/LessonOverview';
import { LessonOverviewContextStore, NewLessonOverviewProps } from './types';

const createLessonOverviewStore = (
  props: NewLessonOverviewProps,
  storeRef: ReturnType<typeof createLessonOverviewStore>,
) => createStore<LessonOverviewContextStore>()((set, get) => ({
  allSlideShows: () => {
    const { isStaffer, oldTCISlideShows, newTCISlideShows, studentSlideShows, teacherSlideShows } = get();

    if (isStaffer) {
      return [
        ...oldTCISlideShows(),
        ...newTCISlideShows(),
        ...teacherSlideShows(),
      ];
    }

    return [...studentSlideShows.tci, ...studentSlideShows.staffer];
  },
  civicsLibrary: props.civicsLibrary ?? false,
  filteredSlideGroups: (displayLocation) => {
    const { slideGroups } = get();

    return slideGroups.filter(slideGroup => (
      slideGroup.displayLocationInLessonOverview === displayLocation
    ));
  },
  finalSlideGroups: () => {
    const { filteredSlideGroups } = get();

    return filteredSlideGroups('put_it_all_together');
  },
  firstTCISlideShow: () => {
    const { isStaffer, slideShows, studentSlideShows } = get();

    if (isStaffer) return slideShows?.tci?.first;

    return studentSlideShows.tci[0];
  },
  hasAssessments: props.hasAssessments,
  introSlideGroups: () => {
    const { filteredSlideGroups } = get();

    return filteredSlideGroups('introduce_the_lesson');
  },
  isLoading: props.isLoading,
  isStaffer: !!props.stafferId,
  lesson: props.lesson,
  lessonId: props.lessonId,
  lessonOptionsSlideGroups: () => {
    const { filteredSlideGroups } = get();

    return filteredSlideGroups('lesson_options');
  },
  locale: props.locale,
  newTCISlideShows: () => {
    const { isStaffer, slideShows } = get();

    if (isStaffer) return slideShows?.tci?.newSlideShows ?? [];

    return [];
  },
  oldTCISlideShows: () => {
    const { isStaffer, slideShows } = get();

    if (isStaffer) return slideShows?.tci?.oldSlideShows ?? [];

    return [];
  },
  primarySourceLibrary: props.primarySourceLibrary ?? false,
  program: props.program,
  programColor: props.program.overviewColor,
  programId: props.programId,
  sections: props.sections,
  setLesson: lesson => set({ lesson }),
  slideGroups: props.slideGroups ?? [],
  slideShows: (props.stafferId ? (props.slideShows as any as StafferSlideShows) : null),
  stafferId: props.stafferId,
  storeRef,
  studentSlideShows: (props.stafferId ? null : (props.slideShows as any as StudentSlideShows)),
  teacherSlideShows: () => {
    const { isStaffer, slideShows, studentSlideShows } = get();

    if (isStaffer) return slideShows?.staffer ?? [];

    return studentSlideShows?.staffer;
  },
  unitColor: props.unitColor,
  unitId: props.unitId,
}));

export default createLessonOverviewStore;
